import React, { useEffect, useState } from "react";

import {
  Card,
  Button,
  Table,
  Modal,
  Form,
  Input,
  Space,
  Popconfirm,
  message,
} from "antd";

import {EditOutlined, DeleteOutlined} from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRouteAreas,
  saveRouteArea,
  deleteRouteArea,
} from "../workRoutesThunk";

const Areas = () => {
  const dispatch = useDispatch();

  const { routeAreas } = useSelector(
    (state) => state.workRoutes
  );

  const [open, setOpen] = useState(false);

  const [editing, setEditing] =
    useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchRouteAreas());
  }, [dispatch]);

  const openAddModal = () => {
    setEditing(null);

    form.resetFields();

    setOpen(true);
  };

  const openEditModal = (record) => {
    setEditing(record);

    form.setFieldsValue(record);

    setOpen(true);
  };

  const handleSave = async () => {
    try {
      const values =
        await form.validateFields();

      await dispatch(
        saveRouteArea({
          ...values,
          id: editing?.id,
        })
      ).unwrap();

      message.success(
        editing
          ? "Area updated"
          : "Area created"
      );

      dispatch(fetchRouteAreas());

      setOpen(false);

      setEditing(null);

      form.resetFields();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(
        deleteRouteArea({ id })
      ).unwrap();

      message.success(
        "Area deleted"
      );

      dispatch(fetchRouteAreas());
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      title: "Area Name",
      dataIndex: "name",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            onClick={() =>
              openEditModal(record)
            }
            icon={<EditOutlined/>}
          />
            

          <Popconfirm
            title="Delete Area?"
            onConfirm={() =>
              handleDelete(record.id)
            }
          >
            <Button danger icon={<DeleteOutlined/>}/>
              
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        title="Areas"
        extra={
          <Button
            type="primary"
            onClick={openAddModal}
          >
            Add Area
          </Button>
        }
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={routeAreas}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </Card>

      <Modal
        open={open}
        title={
          editing
            ? "Edit Area"
            : "Add Area"
        }
        onOk={handleSave}
        onCancel={() =>
          setOpen(false)
        }
      >
        <Form
          layout="vertical"
          form={form}
        >
          <Form.Item
            label="Area Name"
            name="name"
            rules={[
              {
                required: true,
                message:
                  "Area name required",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Areas;